/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Benefit_Audit_RetentionInputs */



/**
* | output |
* | --- |
* | "7-day retention on Starter, 90 days on Team" |
*
* @param {Plan_Gate_Benefit_Audit_RetentionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_benefit_audit_retention = /** @type {((inputs?: Plan_Gate_Benefit_Audit_RetentionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Benefit_Audit_RetentionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("7 Tage Aufbewahrung bei Starter, 90 Tage bei Team")
	return /** @type {LocalizedString} */ ("7-day retention on Starter, 90 days on Team")
});